import React, { ReactElement } from 'react';

// locales
import { useTranslation } from 'react-i18next';
import { translations } from 'locales/i18n';

import TagManager from 'react-gtm-module';
import { useSelector } from 'react-redux';
import { selectProfile } from 'store/profile/selectors';
import { selectIsAuthenticated } from 'store/app/selectors';

// components
// import CKDCalculatorPopup from '../CalculatorsPopups/CKD';
// import IMTCalculatorPopup from '../CalculatorsPopups/IMT';
// import SCORECalculatorPopup from '../CalculatorsPopups/SCORE';
// import CHA2DS2VAScCalculatorPopup from '../CalculatorsPopups/CHA2DS2VASc';
// import HASBLEDCalculatorPopup from '../CalculatorsPopups/HASBLED';
// import PESICalculatorPopup from '../CalculatorsPopups/PESI';
// import GRACECalculatorPopup from '../CalculatorsPopups/GRACE';
// import PADUACalculatorPopup from '../CalculatorsPopups/PADUA';
// import DAPTSCALECalculatorPopup from '../CalculatorsPopups/DAPTSCALE';
// import GOODWILLCalculatorPopup from '../CalculatorsPopups/GOODWILL';
// import MIOCARDCalculatorPopup from '../CalculatorsPopups/MIOCARD';

import Button from '../../../../atoms/Button';

// types
import {
  ButtonGroups,
  ButtonSizes,
  ButtonTypes,
} from '../../../../atoms/Button/types';

// styles
import {
  Wrapper,
  Header,
  Inner,
  Title,
  Description,
  // TriggerContainer,
  Link,
} from './styles';
import HTMLReactParser from 'html-react-parser';

// types
interface IProps {
  icon: string;
  title: string;
  name: string;
  description: string | null;
  type: string;
  url: string | undefined;
  buttonText: string | undefined;
}

export const CalcListItem = ({
  icon,
  title,
  name,
  description,
  type,
  url,
  buttonText,
}: IProps) => {
  // place here switch statement to chose which popup need to be displayed
  // const resPopup = switch ...

  // locales hook
  const { t } = useTranslation();

  const profileInfo = useSelector(selectProfile);
  const isLoggedIn = useSelector(selectIsAuthenticated);

  return (
    <Wrapper isPreview={type === 'preview'}>
      <Header>
        <Title>{title}</Title>

        {icon ? <img src={icon} alt="Калькулятор" /> : ''}
      </Header>
      <Inner>
        <Description>
          {HTMLReactParser(description ? description : '')}
        </Description>

        {url ? (
          <a
            href={url}
            target="_blank"
            onClick={() => {
              if (isLoggedIn) {
                const tagManagerArgs = {
                  gtmId: process.env.REACT_APP_GTM_ID,
                  dataLayer: {
                    event: 'calculator', //Статическое значение.
                    category: 'click', //Статическое значение
                    action: title, //Переменная. Название калькулятора.
                    label:
                      type === 'preview' ? 'Головна' : 'Медичні калькулятори', //Название страницы размещения калькулятора.
                    uid: profileInfo?.data?.id, //User ID. Id зарегистрированного пользователя.
                  },
                };

                TagManager.initialize(tagManagerArgs);
              }
            }}
            rel="noreferrer"
          >
            <Button
              text={
                buttonText
                  ? buttonText
                  : t(translations.calculatorsPage.actions.calcCardButton)
              }
              type={ButtonTypes.Button}
              group={ButtonGroups.Primary}
              size={ButtonSizes.Regular}
              loading={false}
            />
          </a>
        ) : (
          <Link
            to={`/applications-and-calculators/calculators/${name}`}
            onClick={() => {
              if (isLoggedIn) {
                const tagManagerArgs = {
                  gtmId: process.env.REACT_APP_GTM_ID,
                  dataLayer: {
                    event: 'calculator', //Статическое значение.
                    category: 'click', //Статическое значение
                    action: title, //Переменная. Название калькулятора.
                    label:
                      type === 'preview' ? 'Головна' : 'Медичні калькулятори', //Название страницы размещения калькулятора.
                    uid: profileInfo?.data?.id, //User ID. Id зарегистрированного пользователя.
                  },
                };

                TagManager.initialize(tagManagerArgs);
              }
            }}
          >
            <Button
              text={
                buttonText
                  ? buttonText
                  : t(translations.calculatorsPage.actions.calcCardButton)
              }
              type={ButtonTypes.Button}
              group={ButtonGroups.Primary}
              size={ButtonSizes.Regular}
              loading={false}
            />
          </Link>
        )}
      </Inner>
    </Wrapper>
  );
};

export default CalcListItem;
